import moment from "moment";
import * as Yup from "yup"
import EventOption from "./EventOption";

export default class EventOptionGroup {
    static TYPE_SINGLE = 'single';
    static TYPE_MULTIPLE = 'multiple';

    id;
    event;
    type = EventOptionGroup.TYPE_SINGLE;
    required = false;
    sort_order = 0;
    used = false;
    contents = [];
    options = [];

    // Content in the selected language (form)
    title = '';
    description = '';

    static schema = () => Yup.object({
        title: Yup.string().required('CMS.Event.option.group.form.title').max(255, 'CMS.Event.option.group.form.title|255|max'),
        type: Yup.string().required('CMS.Event.option.group.form.type')
    });

    static fromJson = (json, language = null) => {
        let item = new EventOptionGroup();

        item.id = json.id;
        item.event = json.event;
        item.type = json.type;
        item.required = !!json.required;
        item.sort_order = json.sort_order;
        item.used = !!json.used;
        item.contents = (json.contents || []).map(content => ({ ...content, updated_at: content.updated_at ? moment(content.updated_at) : null }));
        item.options = (json.options || []).map(option => EventOption.fromJson(option, language));

        let content = item.getContent(language);
        item.title = content?.title || '';
        item.description = content?.description || '';

        return item;
    }

    getContent = (language = null) => this.contents.filter(content => content.language === language)[0] || this.contents[0];

    isSingle = () => this.type === EventOptionGroup.TYPE_SINGLE;

    activeOptions = () => this.options.filter(option => option.active);
}
